import Object from "./Object.svelte"
import ObjectArray from "./ObjectArray.svelte"
import Number from "./Number.svelte"
import Radio from "./Radio.svelte"
import InfoText from "./InfoText.svelte"
import Textarea from "./Textarea.svelte"
import Text from "./Text.svelte"
import Date from "./Date.svelte"
import DateTime from "./DateTime.svelte"
import Checkbox from "./Checkbox.svelte"
import Images from "./Images.svelte"
import Select from "./Select.svelte"
import VehicleSelect from "./VehicleSelect.svelte"
import UsageAmountObjects from "./UsageAmountObjects.svelte"
import DisposalAmountObjects from "./DisposalAmountObjects.svelte"
import Signature from "./Signature.svelte"

const widgets: Record<WidgetTypes, any> = {
    text: Text,
    string: Text,
    textarea: Textarea,
    object: Object,
    objectArray: ObjectArray,
    "object[]": ObjectArray,
    date: Date,
    dateTime: DateTime,
    checkbox: Checkbox,
    radio: Radio,
    content: InfoText,
    images: Images,
    "image[]": Images,
    disposalAmountObjects: DisposalAmountObjects,
    signature: Signature,
    number: Number,
    select: Select,
    "select[]": Select,
    vehicleSelect: VehicleSelect,
    usageAmountObjects: UsageAmountObjects,
}
export default widgets
